(function () {
  if (!window.fetch) {
    return;
  }

  var parser = new DOMParser();
  var cartBusyCount = 0;

  function getShopRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function getUrl(path) {
    return getShopRoot() + path.replace(/^\//, '');
  }

  function toInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function setFormBusy(form, isBusy) {
    if (!form) return;

    form.dataset.loading = isBusy ? 'true' : 'false';

    var submit = form.querySelector('[data-transaction-add-button]');
    if (submit) {
      if (!submit.hasAttribute('data-default-disabled')) {
        submit.setAttribute('data-default-disabled', submit.disabled ? 'true' : 'false');
      }
      submit.disabled = isBusy || submit.getAttribute('data-default-disabled') === 'true';
      submit.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    }
  }

  function clearError(scope) {
    if (!scope) return;

    var error = scope.querySelector('[data-transaction-error]');
    if (!error) return;

    error.hidden = true;
    error.textContent = '';
  }

  function showError(scope, message) {
    if (!scope) return;

    var error = scope.querySelector('[data-transaction-error]');
    if (!error) return;

    error.hidden = false;
    error.textContent = message || 'Something went wrong. Please try again.';
  }

  function setCartBusy(isBusy) {
    var drawer = getDrawer();
    if (!drawer) return;
    if (isBusy) {
      drawer.dataset.cartBusy = 'true';
    } else {
      delete drawer.dataset.cartBusy;
    }
  }

  function setCartFeedback(message) {
    document.querySelectorAll('[data-cart-feedback]').forEach(function (node) {
      if (!message) {
        node.hidden = true;
        node.textContent = '';
        return;
      }

      node.hidden = false;
      node.textContent = message;
    });
  }

  function getCartSectionTargets() {
    var targets = [];

    var header = document.querySelector('.site-header[data-section-id]');
    if (header && header.querySelector('[data-cart-count]')) {
      targets.push({ id: header.dataset.sectionId, type: 'header' });
    }

    var drawer = document.querySelector('[data-cart-drawer-section][data-section-id]');
    if (drawer) {
      targets.push({ id: drawer.dataset.sectionId, type: 'drawer' });
    }

    var cartMain = document.querySelector('[data-cart-main][data-section-id]');
    if (cartMain) {
      targets.push({ id: cartMain.dataset.sectionId, type: 'cart-main' });
    }

    return targets.filter(function (target) {
      return target.id;
    });
  }

  function getUniqueSectionIds(targets) {
    return Array.from(new Set((targets || []).map(function (target) {
      return target.id;
    }).filter(Boolean)));
  }

  function parseSection(html, sectionId) {
    if (!html || !sectionId) {
      return null;
    }

    var doc = parser.parseFromString(html, 'text/html');
    return doc.querySelector('[data-section-id="' + sectionId + '"]');
  }

  function applyHeaderSection(sectionId, html) {
    var currentHeader = document.querySelector('.site-header[data-section-id="' + sectionId + '"]') || document.querySelector('.site-header');
    if (!currentHeader) return;

    var currentCount = currentHeader.querySelector('[data-cart-count]');
    var incomingDoc = parser.parseFromString(html, 'text/html');
    var incomingCount = incomingDoc.querySelector('[data-cart-count]');
    if (!incomingCount || !currentCount) return;

    var countValue = toInteger(incomingCount.textContent.trim(), 0);
    currentCount.textContent = String(Math.max(0, countValue));

    if (countValue > 0) {
      currentCount.hidden = false;
      currentCount.removeAttribute('aria-hidden');
    } else {
      currentCount.hidden = true;
      currentCount.setAttribute('aria-hidden', 'true');
    }
  }

  function applyCartSection(sectionId, html) {
    var currentSection = document.querySelector('[data-section-id="' + sectionId + '"]');
    var currentRoot = currentSection ? currentSection.querySelector('[data-transaction-cart-root]') : null;
    if (!currentRoot) return;

    var incomingDoc = parser.parseFromString(html, 'text/html');
    var incomingRoot = incomingDoc.querySelector('[data-transaction-cart-root]');
    if (!incomingRoot) return;

    currentRoot.innerHTML = incomingRoot.innerHTML;
  }

  function applySectionsPayload(sectionsPayload, targets) {
    if (!sectionsPayload || typeof sectionsPayload !== 'object' || !targets || !targets.length) {
      return false;
    }

    var applied = false;

    targets.forEach(function (target) {
      var html = sectionsPayload[target.id];
      if (!html) return;

      if (target.type === 'header') {
        applyHeaderSection(target.id, html);
      } else {
        applyCartSection(target.id, html);
      }

      applied = true;
    });

    return applied;
  }

  async function refreshCartSections() {
    var targets = getCartSectionTargets();
    if (!targets.length) return;

    var sectionIds = getUniqueSectionIds(targets);

    var url = new URL(window.location.href);
    url.searchParams.delete('section_id');
    url.searchParams.set('sections', sectionIds.join(','));
    url.searchParams.set('_', Date.now().toString());

    var response = await fetch(url.toString(), {
      method: 'GET',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache'
      },
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('Unable to refresh cart sections.');
    }

    var payload;
    try {
      payload = await response.json();
    } catch (error) {
      throw new Error('Unable to refresh cart sections.');
    }

    applySectionsPayload(payload, targets);
  }

  function updateCartTriggerState(isOpen) {
    document.querySelectorAll('[data-cart-open]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function getDrawer() {
    return document.querySelector('[data-cart-drawer-section]');
  }

  var lastFocusedBeforeDrawer = null;

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) {
      window.location.href = getUrl('cart');
      return;
    }

    lastFocusedBeforeDrawer = document.activeElement;
    drawer.classList.add('is-open');
    document.documentElement.classList.add('cart-drawer-open');
    updateCartTriggerState(true);

    var closeButton = drawer.querySelector('[data-cart-close]');
    if (closeButton) {
      closeButton.focus();
    }
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;

    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cart-drawer-open');
    updateCartTriggerState(false);

    if (lastFocusedBeforeDrawer && typeof lastFocusedBeforeDrawer.focus === 'function') {
      lastFocusedBeforeDrawer.focus();
      lastFocusedBeforeDrawer = null;
    }
  }

  async function addToCart(form) {
    var formData = new FormData(form);
    var variantId = toInteger(formData.get('id'), null);
    var quantity = toInteger(formData.get('quantity'), 1);
    var targets = getCartSectionTargets();
    var sectionIds = getUniqueSectionIds(targets);

    if (!variantId) {
      showError(form.closest('[data-transaction-product], .product-card__purchase') || form, 'Please select a valid option.');
      return;
    }

    clearError(form.closest('[data-transaction-product], .product-card__purchase') || form);
    setCartFeedback('');
    setFormBusy(form, true);

    try {
      var sellingPlanValue = formData.get('selling_plan');
      var item = {
        id: variantId,
        quantity: quantity > 0 ? quantity : 1
      };

      if (sellingPlanValue) {
        item.selling_plan = toInteger(sellingPlanValue, null);
      }

      var requestBody = {
        items: [item]
      };

      if (sectionIds.length) {
        requestBody.sections = sectionIds.join(',');
        requestBody.sections_url = window.location.pathname + window.location.search;
      }

      var response = await fetch(getUrl('cart/add.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      var payload = await response.json();

      if (!response.ok) {
        throw new Error(payload && payload.description ? payload.description : 'Unable to add to cart.');
      }

      var appliedSections = applySectionsPayload(payload && payload.sections ? payload.sections : null, targets);
      if (!appliedSections) {
        await refreshCartSections();
      }
      openDrawer();
    } catch (error) {
      showError(form.closest('[data-transaction-product], .product-card__purchase') || form, error.message);
    } finally {
      setFormBusy(form, false);
    }
  }

  async function updateCartLine(line, quantity, sourceNode) {
    var parsedLine = toInteger(line, null);
    var parsedQuantity = Math.max(0, toInteger(quantity, 0));
    var targets = getCartSectionTargets();
    var sectionIds = getUniqueSectionIds(targets);

    if (!parsedLine) return;

    setCartFeedback('');

    var lineNode = sourceNode && sourceNode.closest ? sourceNode.closest('[data-cart-line]') : null;
    if (lineNode) {
      lineNode.classList.add('is-updating');
    }

    cartBusyCount++;
    setCartBusy(true);

    try {
      var requestBody = {
        line: parsedLine,
        quantity: parsedQuantity
      };

      if (sectionIds.length) {
        requestBody.sections = sectionIds.join(',');
        requestBody.sections_url = window.location.pathname + window.location.search;
      }

      var response = await fetch(getUrl('cart/change.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      var payload = await response.json();

      if (!response.ok) {
        throw new Error(payload && payload.description ? payload.description : 'Unable to update cart.');
      }

      var appliedSections = applySectionsPayload(payload && payload.sections ? payload.sections : null, targets);
      if (!appliedSections) {
        await refreshCartSections();
      }
    } catch (error) {
      setCartFeedback(error.message);
    } finally {
      if (lineNode) {
        lineNode.classList.remove('is-updating');
      }
      cartBusyCount = Math.max(0, cartBusyCount - 1);
      setCartBusy(cartBusyCount > 0);
    }
  }

  function resolveVariantFromOptions(productRoot) {
    if (!productRoot) return null;

    var mapNode = productRoot.querySelector('[data-transaction-variant-map]');
    if (!mapNode) return null;

    var variants;
    try {
      variants = JSON.parse(mapNode.textContent);
    } catch (e) {
      return null;
    }

    var selectedOptions = {};
    productRoot.querySelectorAll('[data-transaction-option-radio]:checked').forEach(function (input) {
      selectedOptions['option' + input.dataset.optionPosition] = input.value;
    });

    var match = variants.find(function (variant) {
      return Object.keys(selectedOptions).every(function (key) {
        return variant[key] === selectedOptions[key];
      });
    });

    return match ? match.id : null;
  }

  async function renderVariantSection(productRoot, variantId) {
    if (!productRoot || !variantId) return;

    var sectionId = productRoot.dataset.sectionId;
    if (!sectionId) return;

    productRoot.classList.add('is-loading');

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('variant', variantId);
      url.searchParams.delete('sections');

      var response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          Accept: 'text/html'
        }
      });

      if (!response.ok) {
        throw new Error('Unable to refresh variant details.');
      }

      var html = await response.text();
      var incomingSection = parseSection(html, sectionId);
      var currentSection = document.querySelector('[data-section-id="' + sectionId + '"]');
      if (!incomingSection || !currentSection) {
        return;
      }

      var currentMediaNode = currentSection.querySelector('[data-transaction-media]');
      var incomingMediaNode = incomingSection.querySelector('[data-transaction-media]');
      if (currentMediaNode && incomingMediaNode) {
        currentMediaNode.innerHTML = incomingMediaNode.innerHTML;
      }

      // Remember subscription state before replacing HTML
      var wasSubscribed = isSubscriptionActive(productRoot);

      var currentPurchaseNode = currentSection.querySelector('[data-transaction-purchase]');
      var incomingPurchaseNode = incomingSection.querySelector('[data-transaction-purchase]');
      if (currentPurchaseNode && incomingPurchaseNode) {
        currentPurchaseNode.outerHTML = incomingPurchaseNode.outerHTML;
      }

      // Re-apply subscription state after HTML replacement
      if (wasSubscribed) {
        var updatedProductRoot = currentSection.querySelector('[data-transaction-product]') || productRoot;
        activateSubscription(updatedProductRoot);
      }

      var browserUrl = new URL(window.location.href);
      browserUrl.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', browserUrl.toString());

      if (typeof window.ScrollTrigger !== 'undefined' && typeof window.ScrollTrigger.refresh === 'function') {
        window.ScrollTrigger.refresh();
      }

      clearError(productRoot);
    } catch (error) {
      showError(productRoot, error.message);
    } finally {
      productRoot.classList.remove('is-loading');
    }
  }

  /* ── Selling plan / subscription toggle ──────────────────── */

  function getSellingPlanGroup(productRoot) {
    if (!productRoot) return null;
    return productRoot.querySelector('[data-selling-plan-group]');
  }

  function getVariantMapEntry(productRoot) {
    if (!productRoot) return null;

    var mapNode = productRoot.querySelector('[data-transaction-variant-map]');
    if (!mapNode) return null;

    var variants;
    try {
      variants = JSON.parse(mapNode.textContent);
    } catch (e) {
      return null;
    }

    var variantInput = productRoot.querySelector('[data-transaction-selected-variant]');
    if (!variantInput) return null;

    var variantId = toInteger(variantInput.value, null);
    return variants.find(function (v) { return v.id === variantId; }) || null;
  }

  function updateButtonPrice(productRoot, useSellingPlan) {
    if (!productRoot) return;

    var entry = getVariantMapEntry(productRoot);
    if (!entry) return;

    // Update Add to Cart button
    var button = productRoot.querySelector('[data-transaction-add-button]');
    if (button && !button.disabled) {
      var price = useSellingPlan && entry.selling_plan_price ? entry.selling_plan_price : entry.price;
      button.textContent = price + ' • Add to Cart';
    }

    // Update inline prices on subscription option cards
    var subscribePriceEl = productRoot.querySelector('[data-selling-plan-subscribe-price]');
    if (subscribePriceEl && entry.selling_plan_price) {
      var strikeEl = subscribePriceEl.querySelector('.selling-plan-option__strike');
      if (strikeEl) {
        strikeEl.textContent = entry.price;
      }
      // Set the non-strike text (the last text node)
      subscribePriceEl.lastChild.textContent = entry.selling_plan_price;
    }

    var onetimePriceEl = productRoot.querySelector('[data-selling-plan-onetime-price]');
    if (onetimePriceEl) {
      onetimePriceEl.textContent = entry.price;
    }
  }

  function isSubscriptionActive(productRoot) {
    var group = getSellingPlanGroup(productRoot);
    return group ? group.classList.contains('selling-plan-group-selected') : false;
  }

  function setSellingPlan(productRoot, sellingPlanId) {
    if (!productRoot) return;

    var sellingPlanInput = productRoot.querySelector('[data-transaction-selling-plan]');
    if (sellingPlanInput) {
      sellingPlanInput.value = sellingPlanId || '';
    }

    var sellingPlanSelect = productRoot.querySelector('[data-selling-plan-select]');
    if (sellingPlanSelect && sellingPlanId) {
      sellingPlanSelect.value = sellingPlanId;
    }
  }

  function activateSubscription(productRoot) {
    var group = getSellingPlanGroup(productRoot);
    if (!group) return;

    group.classList.add('selling-plan-group-selected');

    var sellingPlanSelect = productRoot.querySelector('[data-selling-plan-select]');
    var sellingPlanId = '';

    if (sellingPlanSelect) {
      if (sellingPlanSelect.value) {
        sellingPlanId = sellingPlanSelect.value;
      } else {
        var firstOption = sellingPlanSelect.querySelector('option[value]:not([value=""])');
        if (firstOption) {
          sellingPlanId = firstOption.value;
          sellingPlanSelect.value = sellingPlanId;
        }
      }
    }

    // For products with only one selling plan and no select element
    if (!sellingPlanId) {
      var addBtn = productRoot.querySelector('[data-add-subscription]');
      if (addBtn && addBtn.dataset.sellingPlanId) {
        sellingPlanId = addBtn.dataset.sellingPlanId;
      }
    }

    setSellingPlan(productRoot, sellingPlanId);
    updateButtonPrice(productRoot, true);

    if (sellingPlanId) {
      sessionStorage.setItem('selling_plan_' + sellingPlanId, 'added');
    }

    var browserUrl = new URL(window.location.href);
    if (sellingPlanId) {
      browserUrl.searchParams.set('selling_plan', sellingPlanId);
    }
    window.history.replaceState({}, '', browserUrl.toString());
  }

  function deactivateSubscription(productRoot) {
    var group = getSellingPlanGroup(productRoot);
    if (!group) return;

    group.classList.remove('selling-plan-group-selected');

    var sellingPlanSelect = productRoot.querySelector('[data-selling-plan-select]');
    if (sellingPlanSelect) {
      var firstOption = sellingPlanSelect.querySelector('option[value]:not([value=""])');
      if (firstOption) {
        sessionStorage.setItem('selling_plan_' + firstOption.value, 'removed');
      }
    }

    setSellingPlan(productRoot, '');
    updateButtonPrice(productRoot, false);

    var browserUrl = new URL(window.location.href);
    browserUrl.searchParams.delete('selling_plan');
    window.history.replaceState({}, '', browserUrl.toString());
  }

  function autoSelectSellingPlans() {
    document.querySelectorAll('[data-selling-plan-auto-select]').forEach(function (group) {
      var params = window.location.search;
      if (params.includes('variant') || params.includes('selling_plan')) return;

      var productRoot = group.closest('[data-transaction-product]');
      if (!productRoot) return;

      var sellingPlanSelect = productRoot.querySelector('[data-selling-plan-select]');
      var planId = '';

      if (sellingPlanSelect) {
        var firstOption = sellingPlanSelect.querySelector('option[value]:not([value=""])');
        if (!firstOption) return;
        planId = firstOption.value;
      } else {
        var addBtn = productRoot.querySelector('[data-add-subscription]');
        if (!addBtn || !addBtn.dataset.sellingPlanId) return;
        planId = addBtn.dataset.sellingPlanId;
      }

      if (sessionStorage.getItem('selling_plan_' + planId) === 'removed') return;

      activateSubscription(productRoot);
    });
  }

  // Run auto-select on load
  autoSelectSellingPlans();

  /* ── Event listeners ───────────────────────────────────── */

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-transaction-add-form]');
    if (!form) return;

    event.preventDefault();
    addToCart(form);
  });

  document.addEventListener('change', function (event) {
    var optionInput = event.target.closest('[data-transaction-option-radio]');
    if (optionInput && optionInput.checked) {
      var productRoot = optionInput.closest('[data-transaction-product]');
      var variantId = resolveVariantFromOptions(productRoot);
      if (variantId) {
        renderVariantSection(productRoot, variantId);
      }
      return;
    }

    var qtyInput = event.target.closest('[data-cart-qty-input]');
    if (qtyInput) {
      updateCartLine(qtyInput.dataset.line, qtyInput.value, qtyInput);
      return;
    }

    var sellingPlanSelect = event.target.closest('[data-selling-plan-select]');
    if (sellingPlanSelect) {
      var productRoot = sellingPlanSelect.closest('[data-transaction-product]');
      if (productRoot) {
        setSellingPlan(productRoot, sellingPlanSelect.value);

        // Update URL with new selling plan
        var browserUrl = new URL(window.location.href);
        if (sellingPlanSelect.value) {
          browserUrl.searchParams.set('selling_plan', sellingPlanSelect.value);
        }
        window.history.replaceState({}, '', browserUrl.toString());
      }
    }
  });

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-cart-open]');
    if (openTrigger) {
      event.preventDefault();
      openDrawer();
      return;
    }

    var closeTrigger = event.target.closest('[data-cart-close]');
    if (closeTrigger) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var backdrop = event.target.closest('[data-cart-drawer-backdrop]');
    if (backdrop) {
      closeDrawer();
      return;
    }

    var qtyButton = event.target.closest('[data-cart-qty-change]');
    if (qtyButton) {
      event.preventDefault();
      updateCartLine(qtyButton.dataset.line, qtyButton.dataset.quantity, qtyButton);
      return;
    }

    var addSubscription = event.target.closest('[data-add-subscription]');
    if (addSubscription) {
      event.preventDefault();
      var productRoot = addSubscription.closest('[data-transaction-product]');
      activateSubscription(productRoot);
      return;
    }

    var removeSubscription = event.target.closest('[data-remove-subscription]');
    if (removeSubscription) {
      event.preventDefault();
      var productRoot = removeSubscription.closest('[data-transaction-product]');
      deactivateSubscription(productRoot);
      return;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawer();
    }
  });

})();
